<template>
  <div class="empty_layout">
    <router-view/>
  </div>
</template>

<script>
export default {
}
</script>

<style>

</style>
